export const validateFileSize = (fileList, maxSize) => {
  let isValid = true
  for (let i = 0; i < fileList.length; i++) {
    if (fileList[i].size > maxSize) {
      isValid = false
    }
  }

  return isValid
}

export const fileListObjectIsNotEmpty = (fileListObj) => !!fileListObj?.length

export const isEmailString = (val) => {
  const regex =
    // eslint-disable-next-line no-control-regex
    /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i
  const trimmedVal = val && val.trim()
  return !!(trimmedVal && trimmedVal.match(regex))
}

export const isNotEmptyString = (val) => !!val
